import React from 'react';

const SvgAlert = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 15.94c-.493 0-.9.143-1.22.43-.32.287-.48.657-.48 1.11 0 .453.16.82.48 1.1.32.28.727.42 1.22.42.507 0 .917-.14 1.23-.42.313-.28.47-.647.47-1.1 0-.453-.157-.823-.47-1.11-.313-.287-.723-.43-1.23-.43zm1.48-11.38h-2.94v9.92h2.94V4.56z",
  fillRule: "evenodd"
}));

export default SvgAlert;